/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type DashboardTopGoalscorersCard_topGoalScorersQuery$ref = any;
export type DashboardPageQueryVariables = {||};
export type DashboardPageQueryResponse = {|
  +$fragmentRefs: DashboardTopGoalscorersCard_topGoalScorersQuery$ref
|};
export type DashboardPageQuery = {|
  variables: DashboardPageQueryVariables,
  response: DashboardPageQueryResponse,
|};
*/


/*
query DashboardPageQuery {
  ...DashboardTopGoalscorersCard_topGoalScorersQuery
}

fragment DashboardTopGoalscorersCard_topGoalScorersQuery on Query {
  topGoalScorers: playerSeasonAggregations(first: 5, sortColumn: "iGoals", sortDirection: "desc", fromSeason: "20192020", toSeason: "20192020") {
    edges {
      node {
        id
        player {
          fullName
          id
        }
        gamesPlayed
        iGoals
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardPageQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "DashboardTopGoalscorersCard_topGoalScorersQuery"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DashboardPageQuery",
    "selections": [
      {
        "alias": "topGoalScorers",
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 5
          },
          {
            "kind": "Literal",
            "name": "fromSeason",
            "value": "20192020"
          },
          {
            "kind": "Literal",
            "name": "sortColumn",
            "value": "iGoals"
          },
          {
            "kind": "Literal",
            "name": "sortDirection",
            "value": "desc"
          },
          {
            "kind": "Literal",
            "name": "toSeason",
            "value": "20192020"
          }
        ],
        "concreteType": "PlayerSeasonAggregationConnection",
        "kind": "LinkedField",
        "name": "playerSeasonAggregations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PlayerSeasonAggregationEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PlayerSeasonAggregation",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Player",
                    "kind": "LinkedField",
                    "name": "player",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fullName",
                        "storageKey": null
                      },
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "gamesPlayed",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "iGoals",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "playerSeasonAggregations(first:5,fromSeason:\"20192020\",sortColumn:\"iGoals\",sortDirection:\"desc\",toSeason:\"20192020\")"
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "DashboardPageQuery",
    "operationKind": "query",
    "text": "query DashboardPageQuery {\n  ...DashboardTopGoalscorersCard_topGoalScorersQuery\n}\n\nfragment DashboardTopGoalscorersCard_topGoalScorersQuery on Query {\n  topGoalScorers: playerSeasonAggregations(first: 5, sortColumn: \"iGoals\", sortDirection: \"desc\", fromSeason: \"20192020\", toSeason: \"20192020\") {\n    edges {\n      node {\n        id\n        player {\n          fullName\n          id\n        }\n        gamesPlayed\n        iGoals\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd67aeed6c7cafa8675515e9b6124dd5b';

module.exports = node;
